import { useEffect, useLayoutEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * Globaler Scroll-Restorer für HashRouter.
 * - Setzt browser-eigene Scroll-Restoration auf "manual", damit kein
 *   automatisches Zurückspringen passiert (Safari/Chrome).
 * - Bei JEDEM Routenwechsel ohne Anker (inner hash) wird zuverlässig nach
 *   ganz oben gescrollt — synchron via useLayoutEffect (vor Paint).
 * - Bei Routenwechsel mit innerem Anker (#section-...) wird das Ziel-
 *   element sanft angesprungen, sobald es im DOM steht.
 */
export default function ScrollToTop() {
  const { pathname, hash, key } = useLocation();

  // Browser-Scroll-Restoration ausschalten (einmalig)
  useEffect(() => {
    if ("scrollRestoration" in window.history) {
      const prev = window.history.scrollRestoration;
      window.history.scrollRestoration = "manual";
      return () => {
        window.history.scrollRestoration = prev;
      };
    }
  }, []);

  // Bei JEDEM Routen-Wechsel: synchron nach oben, bevor der Browser paintet
  useLayoutEffect(() => {
    if (!hash) {
      window.scrollTo(0, 0);
      document.documentElement.scrollTop = 0;
      document.body.scrollTop = 0;
    }
  }, [pathname, hash, key]);

  // Wenn ein innerer Anker gesetzt ist: nach Mount sanft hinscrollen
  useEffect(() => {
    if (!hash) return;
    const id = hash.replace(/^#/, "");
    const t = setTimeout(() => {
      const el = document.getElementById(id);
      if (el) {
        el.scrollIntoView({ behavior: "smooth", block: "start" });
      } else {
        window.scrollTo(0, 0);
      }
    }, 80);
    return () => clearTimeout(t);
  }, [pathname, hash, key]);

  return null;
}
